document.addEventListener('DOMContentLoaded', function () {
  let currentDisplayType = "normal"; // Tracks the last displayed type
  let lastProgress = 0; // Tracks the last known progress to prevent bouncing
    let lastIndicatorPosition = 0; // Tracks last known position of the indicator
    
  // Function to toggle the checkout button based on cart total
  function toggleCheckoutButton() {
    const cartTotalElement = document.querySelector('.wcp-original-cart-total');
    const checkoutButton = document.getElementById('checkout-button');
    const additionalCheckoutButtons = document.querySelector('.cart__dynamic-checkout-buttons.additional-checkout-buttons');

    if (cartTotalElement && checkoutButton) {
      const cartTotal = parseFloat(cartTotalElement.innerText.replace('$', '').replace(/,/g, ''));
      const shouldShowCheckout = cartTotal >= 60;

      if (shouldShowCheckout && checkoutButton.style.display !== 'block') {
        checkoutButton.style.display = 'block';
        if (additionalCheckoutButtons) additionalCheckoutButtons.style.display = 'block';
      } else if (!shouldShowCheckout && checkoutButton.style.display !== 'none') {
        checkoutButton.style.display = 'none';
        if (additionalCheckoutButtons) additionalCheckoutButtons.style.display = 'none';
      }
    }
  }

function updateProgressBar() {
  const cartTotalElement = document.querySelector('.wcp-original-cart-total');
  const progressBarContainer = document.querySelector('.progress-bar-container');
  const progressFill = document.querySelector('.progress-fill');
  const progressIndicator = document.querySelector('.progress-indicator');
  const progressTitle = document.querySelector('.progress-title');

  if (cartTotalElement && progressBarContainer && progressFill && progressIndicator && progressTitle) {
    const cartTotal = parseFloat(cartTotalElement.innerText.replace('$', '').replace(/,/g, ''));
    const shouldHideProgress = cartTotal >= 60;

    if (shouldHideProgress) {
      progressBarContainer.style.display = 'none';
      progressTitle.style.display = 'none';
    } else {
      // Calculate the current progress percentage based on the cart total
      const progress = (cartTotal / 60) * 100;

      // Ensure progress bar container is visible and reset opacity if hidden
      if (progressBarContainer.style.display === 'none') {
        progressBarContainer.style.display = 'block';
        progressTitle.style.display = 'block';
      }

      // Immediately set the correct progress on the progress bar and indicator
      progressFill.style.width = progress + '%';
      progressIndicator.style.left = `calc(${progress}% - 10px)`; // Offset by half of indicator width

      // Update the last known progress to prevent unnecessary updates
      lastProgress = progress;

      // Ensure the opacity is fully visible
      progressBarContainer.style.opacity = '1';
      progressTitle.style.opacity = '1';
    }
  }
}



  // Initialize progress bar once on page load to set initial progress
  updateProgressBar();

  // Function to update visible cart total
  function updateVisibleCartTotal() {
    const cartTotalElement = document.querySelector('.wcp-original-cart-total');
    const visibleCartTotalElement = document.querySelector('.wcp-original-cart-total-visible');

    if (cartTotalElement && visibleCartTotalElement) {
      visibleCartTotalElement.innerText = cartTotalElement.innerText;
    }
  }

  // Function to update delivery dates and apply override if needed
  function updateDeliveryDates() {
    const currentDateTime = new Date();
    const thursdayDeliveryDate = calculateDeliveryDate(currentDateTime, 'Thursday');
    const fridayDeliveryDate = calculateDeliveryDate(currentDateTime, 'Friday');

    const thursdayDateElement = document.getElementById('thursday-delivery-date');
    const fridayDateElement = document.getElementById('friday-delivery-date');

    if (thursdayDateElement) {
      thursdayDateElement.innerText = formatDate(thursdayDeliveryDate);
    }
    if (fridayDateElement) {
      fridayDateElement.innerText = formatDate(fridayDeliveryDate);
    }

    checkAndDisplayOverrideDate(thursdayDeliveryDate, fridayDeliveryDate);
  }

  
function checkAndDisplayOverrideDate(thursday, friday) {
  const publicHolidays = (window.themeSettings.public_holidays || "").split("\n").map(date => date.trim());
  const holidayOverrides = (window.themeSettings.public_holiday_overrides || "").split("\n").map(date => date.trim());
  const holidayOverridesThursday = (window.themeSettings.public_holiday_overrides_thursday || "").split("\n").map(date => date.trim());
  const holidayOverridesFriday = (window.themeSettings.public_holiday_overrides_friday || "").split("\n").map(date => date.trim());

  const startOfWeek = new Date(thursday);
  startOfWeek.setDate(thursday.getDate() - thursday.getDay()); // Sunday
  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6); // Saturday

  let overrideDateText = null;

  function parseThemeDate(dateString) {
    if (!dateString) return null;
    const parsedDate = new Date(dateString.split('/').reverse().join('-'));
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  }

  for (let i = 0; i < publicHolidays.length; i++) {
    const holidayDate = parseThemeDate(publicHolidays[i]);

    if (!holidayDate) {
      continue;
    }

    if (holidayDate >= startOfWeek && holidayDate <= endOfWeek) {
      const legacyOverride = holidayOverrides[i];
      const thursdayOverride = holidayOverridesThursday[i] || legacyOverride;
      const fridayOverride = holidayOverridesFriday[i] || legacyOverride;

      const thursdayOverrideDate = parseThemeDate(thursdayOverride);
      const fridayOverrideDate = parseThemeDate(fridayOverride);

      const thursdayOverrideFormatted = thursdayOverrideDate ? formatDisplayDate(thursdayOverrideDate) : "";
      const fridayOverrideFormatted = fridayOverrideDate ? formatDisplayDate(fridayOverrideDate) : "";

      if (thursdayOverrideFormatted && fridayOverrideFormatted && thursdayOverrideFormatted !== fridayOverrideFormatted) {
        overrideDateText = `${thursdayOverrideFormatted} or ${fridayOverrideFormatted}`;
      } else {
        overrideDateText = thursdayOverrideFormatted || fridayOverrideFormatted || "Date not available";
      }
      break;
    }
  }

  const overrideDateElement = document.getElementById("override-delivery-date");
  const normalDeliveryDates = document.getElementById("normal-delivery-dates");
  const deliveryDateDiv = document.getElementById("delivery-date");

  // Ensure elements are defined
  if (!normalDeliveryDates || !overrideDateElement || !deliveryDateDiv) {
    console.log("One or more elements are missing.");
    return;
  }

  if (overrideDateText) {
    // Only update if not already in override mode
    if (overrideDateElement.textContent !== overrideDateText || currentDisplayType !== "override") {
      overrideDateElement.textContent = overrideDateText;
      deliveryDateDiv.style.opacity = "1"; // Show the override date
      deliveryDateDiv.style.display = "block";
      normalDeliveryDates.style.opacity = "0"; // Hide normal dates
      normalDeliveryDates.style.display = "none";
      currentDisplayType = "override"; // Set display type to "override"
      console.log("Switched to override mode");
    }
  } else {
    // No override, switch to normal mode if not already in it
    if (currentDisplayType !== "normal") {
      normalDeliveryDates.style.opacity = "1"; // Show normal dates
      normalDeliveryDates.style.display = "block";
      deliveryDateDiv.style.opacity = "0"; // Hide the override date
      deliveryDateDiv.style.display = "none";
      currentDisplayType = "normal"; // Set display type to "normal"
      console.log("Switched to normal mode with forced visibility");
    }

    // Additional check to ensure normalDeliveryDates is visible if deliveryDateDiv is hidden
    const deliveryDateOpacity = window.getComputedStyle(deliveryDateDiv).opacity;
    if (deliveryDateOpacity === "0") {
      normalDeliveryDates.style.opacity = "1";
      normalDeliveryDates.style.display = "block";
      console.log("Ensured normalDeliveryDates is visible when deliveryDateDiv is hidden");
    }
  }

  console.log("Current display type after:", currentDisplayType);
}


  // Helper function to format dates as "8th Nov 2024" for display
  function formatDisplayDate(date) {
      const day = date.getDate();
      const month = date.toLocaleString('default', { month: 'short' });
      const year = date.getFullYear();
      const daySuffix = getDaySuffix(day);
      return `${day}${daySuffix} ${month} ${year}`;
  }

  // Helper function to get day suffix (st, nd, rd, th)
  function getDaySuffix(day) {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
          case 1: return "st";
          case 2: return "nd";
          case 3: return "rd";
          default: return "th";
      }
  }

  // Helper functions
  function formatDate(date) {
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    const daySuffix = getDaySuffix(day);
    return `${day}${daySuffix} ${month} ${year}`;
  }

  function calculateDeliveryDate(currentDateTime, deliveryDay) {
    const startOfWeek = new Date(currentDateTime);
    startOfWeek.setDate(currentDateTime.getDate() - currentDateTime.getDay());
    startOfWeek.setHours(20, 1, 0, 0);

    const deliveryDate = new Date(startOfWeek);
    deliveryDate.setDate(deliveryDate.getDate() + 7 + (deliveryDay === 'Thursday' ? 4 : 5));

    if (currentDateTime < startOfWeek) {
      deliveryDate.setDate(deliveryDate.getDate() - 7);
    }

    return deliveryDate;
  }

  // Run all functions on page load to initialize values
  toggleCheckoutButton();
  updateProgressBar();
  updateVisibleCartTotal();
  updateDeliveryDates();

  // Debounce function to control rapid consecutive calls
  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  }

  // Debounced version of the function to update all UI elements
  const debouncedUpdateAll = debounce(function () {
    toggleCheckoutButton();
    updateProgressBar();
    updateVisibleCartTotal();
    updateDeliveryDates();
  }, 500);

  // Set up a MutationObserver to trigger all functions on changes in the cart container
  const cartContainer = document.querySelector('.cart__footer');
  if (cartContainer) {
    let cartObserver;

    const debouncedUpdateAll = debounce(function() {
      toggleCheckoutButton();
      updateProgressBar();
      updateVisibleCartTotal();
      updateDeliveryDates();
      if (cartObserver && cartContainer) {
        cartObserver.observe(cartContainer, { childList: true, subtree: true });
      }
    }, 100);

    cartObserver = new MutationObserver(function(mutations) {
      cartObserver.disconnect();
      debouncedUpdateAll();
    });

    if (cartContainer) {
      cartObserver.observe(cartContainer, { childList: true, subtree: true });
    }
  }
});
